function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by pzf on 18/9/1.
 *
 */

/* eslint func-names: 1 */
import React, { Fragment } from 'react';
import { Icon, Tag } from 'mkui-fd';
import classNames from 'classnames';
import { propTypes, defaultPropTypes } from './PropTypes';

var TagsSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(TagsSelect, _React$Component);

  /** *******************static************************** */

  /** *******************life cycle************************** */
  function TagsSelect(props) {
    var _this;

    _classCallCheck(this, TagsSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TagsSelect).call(this, props));
    _this.state = _this.getInitState(props);
    return _this;
  }
  /** *******************handle************************** */

  /**
   * 标题点击触发
   * @param e
   */


  _createClass(TagsSelect, [{
    key: "clickHandle",
    value: function clickHandle(e) {
      e.stopPropagation();
      e.preventDefault();
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;

      if (!disabled) {
        onClick();
      }
    }
    /** *******************inner method************************** */

  }, {
    key: "getInitState",
    value: function getInitState(props) {
      var value = this.props.value;
      var choosed = [];
    }
  }, {
    key: "getPlaceholderElement",
    value: function getPlaceholderElement() {
      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          prefixCls = _this$props2.prefixCls;

      if (placeholder) {
        return React.createElement("div", {
          className: "".concat(prefixCls, "-placeholder"),
          unselectable: "on"
        }, placeholder);
      }

      return null;
    }
    /** *******************render method************************** */

  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          label = _this$props3.label;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-label")
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-label-text")
      }, label), React.createElement(Icon, {
        className: "".concat(prefixCls, "-label-icon"),
        type: "down"
      }));
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this$props4 = this.props,
          value = _this$props4.value,
          render = _this$props4.render,
          keyName = _this$props4.keyName,
          maxSize = _this$props4.maxSize,
          prefixCls = _this$props4.prefixCls;

      if (value && value.length) {
        var over = value.length > maxSize;
        var limited = over ? value.slice(0, maxSize) : value;
        var content = limited.map(function (item) {
          return React.createElement(Tag, {
            key: item[keyName]
          }, render(item));
        });

        if (over) {
          content.push(React.createElement("span", {
            className: "".concat(prefixCls, "-total")
          }, "\u5171", value.length, "\u9879"));
        }

        return content;
      } else {
        return this.getPlaceholderElement();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          disabled = _this$props5.disabled,
          showLabel = _this$props5.showLabel;
      var rootCls = classNames((_classNames = {}, _defineProperty(_classNames, prefixCls, 1), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
      return React.createElement("div", {
        className: rootCls,
        onClick: function onClick(event) {
          return _this2.clickHandle(event);
        }
      }, showLabel ? this.renderLabel() : null, React.createElement("div", {
        className: "".concat(prefixCls, "-tags")
      }, this.renderTags()));
    }
  }]);

  return TagsSelect;
}(React.Component);

_defineProperty(TagsSelect, "propTypes", propTypes);

_defineProperty(TagsSelect, "defaultProps", defaultPropTypes);

export default TagsSelect;
//# sourceMappingURL=TagsSelect.js.map
